export const ScrollToPlans = (selector, options = {}) => {
  const element = document.querySelector(selector);

  if (!element) {
    console.warn(`scroll to plan section: No element found for ${selector}`);
    return;
  }

  element.scrollIntoView({
    behavior: "smooth",
    block: "start",
    ...options,
  });
};
